'use client';

import { AuthProvider } from '@youversion/next-auth-react';
import * as React from 'react';

import AuthenticatedPage from '@/components/auth/AuthenticatedPage';
import { AppLanguageProvider } from '@/context/appLanguage';
import { getBrowserAuthConfig } from '@/utils/browser-auth-config';

const AUTH_CACHE_DURATION_MS = 300_000;

/**
 * Auth-dependent provider tree shared by every authenticated route group.
 * Composes `AuthProvider`, `AppLanguageProvider` (which depends on
 * `useUser`), and `AuthenticatedPage` (which gates rendering on a valid
 * session).
 *
 * Mount this in any route-group layout that requires an authenticated user
 * (`(dashboard)`, `(auth)`, `(standalone)`). Public route groups must NOT
 * use it, or unauthenticated visitors will trigger a session lookup
 * against `/authenticate`.
 */
export function AuthenticatedProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider authConfig={getBrowserAuthConfig()} cacheDuration={AUTH_CACHE_DURATION_MS}>
      <AppLanguageProvider>
        <AuthenticatedPage>{children}</AuthenticatedPage>
      </AppLanguageProvider>
    </AuthProvider>
  );
}
